<template>
  <div>
    <section role="main" class="empty">
      <div class="container">
        <!-- <div class="row position-relative">
          <div class="filter-position">
          <img src="/img/filter.png" width="32" height="32" data-toggle="modal" data-target="#FilterModalCenter" />
          </div>
        </div> -->
        <div class="row icon-tabs">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <router-link to="/executive" class="nav-link active"
                ><img src="/img/icons/executives.png" alt="Executives" />
                Executives
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/company" class="nav-link"
                ><img src="/img/icons/companies.png" alt="Companies" />
                Companies</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/news" class="nav-link"
                ><img src="/img/icons/deals.png" alt="News" /> News</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/deals-transactions" class="nav-link"
                ><img src="/img/icons/deals.png" alt="Deals & Transactions" />
                Deals & Transactions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/listing" class="nav-link"
                ><img src="/img/book.png" style="height: 23px" />
                Listing</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link to="/commentaries" class="nav-link"
                ><img src="/img/icons/commentaries.png" alt="Commentaries" />
                Commentaries</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link to="/interesting-bites" class="nav-link"
                ><img
                  src="/img/icons/interesting.png"
                  alt="Interesting Facts"
                />
                Interesting Facts</router-link
              >
            </li>
            <!-- NOTE: Temporary hide the open position tab. -->
            <!-- <li class="nav-item">
              <router-link to="/open-positons-new" class="nav-link"
                ><img src="/img/icons/position.png" alt="Open Position" /> Open
                Positons</router-link
              >
            </li> -->
            <li class="">
              <a
                class="nav-link"
                style="
                  font-weight: bold !important;
                  margin-top: 8px;
                  font-size: 13px;
                  color: #1f3342;
                  margin-left: 290px;
                "
              >
                {{ count }}</a
              >
            </li>
          </ul>
          <div class="tab-content mb-3">
            <div>
              <div class="container px-0">
                <div class="row">
                  <div class="col-lg-8 col-sm-8 col-6">
                    <Field
                      type="text"
                      class="search-query"
                      v-on:keyup.enter="getList(0)"
                      placeholder="Search"
                      v-model="searchObj.keyword"
                      style="border: 0px none; width: 100%; padding-left: 0"
                    />
                  </div>
                  <div
                    class="col-lg-4 col-sm-4 col-6 text-right executive-offcanvas">
                    <button class="menuButton" id="openOffcanvas" v-on:click="openCloseModel()">
                      <div class="filter-title-name">Build My Search</div>
                    </button>
                  </div>
                 
                </div>
                <hr class="mt-0 mb-2" />
              </div>
              <div v-if="showDidYouMean" class="did-you-mean">
                Did you mean: <span class="did-you-mean-prompt">{{ searchedPrompt }}</span>
              </div>
              <!-- <hr /> -->
              <div class="col-12 row mt-3">
                <div
                  class="col-lg-4 col-sm-4"
                  v-for="(data, index) in list"
                  :key="index"
                >
                  <div class="rectangle-box">
                    <div class="row" style="height: 115px">
                      <div class="col-lg-3 col-sm-3 col-1 pr-2 text-center">
                        <a>
                          <img
                            v-if="data.executive_logo || !data.gender"
                            :src="
                              data.executive_logo
                                ? data.executive_logo
                                : '/img/user-pic.png'
                            "
                            alt=""
                            class="round"
                          />
                          <img
                            v-if="data.gender == 'male' && !data.executive_logo"
                            :src="
                              data.executive_logo
                                ? data.executive_logo
                                : '/img/male.png'
                            "
                            alt=""
                            class="round"
                          />
                          <img
                            v-if="
                              data.gender == 'female' && !data.executive_logo
                            "
                            :src="
                              data.executive_logo
                                ? data.executive_logo
                                : '/img/female.png'
                            "
                            alt=""
                            class="round"
                          />
                        </a>
                        <br />
                        <a
                          class=""
                          style="margin-left: -6px"
                          :title="data.country ? data.country.country_name : ''"
                        >
                          <country-flag
                            :country="
                              data.country ? data.country.country_code : '-'
                            "
                          />
                        </a>
                      </div>
                      <div
                        class="col-lg-7 col-sm-7 col-9 px-2"
                        style="max-height: 120px"
                      >
                        <a
                          style="cursor: pointer"
                          v-on:click="goToView('/executive-detail/' + data.id)"
                        >
                          <div
                            style="display: initial !important"
                            :title="
                              data.executive_name ? data.executive_name : '-'
                            "
                            class="client-name"
                          >
                            {{
                              data.executive_name ? data.executive_name : "-"
                            }}
                          </div>
                          <div
                            :title="
                              data.new_company
                                ? data.new_company.company_name
                                : '-'
                            "
                            class="company-name"
                          >
                            <img
                              :src="
                                data.new_company
                                  ? data.new_company.company_logo
                                  : '/img/user-pic.png'
                              "
                              style="border-radius: 9px"
                              alt=""
                              width="18"
                              height="18"
                            />
                            {{
                              data.new_company
                                ? data.new_company.company_name
                                : "-"
                            }}
                          </div>
                          <div
                            :title="
                              $helperService.isStringOnlyAlphabet(
                                data.new_job_title_id
                              )
                                ? data.new_job_title_id
                                : data.new_job_title
                                ? data.new_job_title.title
                                : ''
                            "
                            class="designation"
                          >
                            <span>{{
                              $helperService.isStringOnlyAlphabet(
                                data.new_job_title_id
                              )
                                ? data.new_job_title_id
                                : data.new_job_title
                                ? data.new_job_title.title
                                : "-"
                            }}</span>
                          </div>
                        </a>
                        <div class="mt-2">
                          <a
                            :title="
                              data.country != null && data.country.phone_code
                                ? '+' +
                                  data.country.phone_code +
                                  data.executive_phone
                                : ''
                            "
                            target="__blank"
                            :href="
                              'https://api.whatsapp.com/send?phone=' +
                              (data.country != null && data.country.phone_code
                                ? data.country.phone_code + data.executive_phone
                                : '')
                            "
                            style="cursor: pointer"
                            class="mr-1"
                            ><img
                              src="/img/icons/phone.png"
                              height="29"
                              width="29"
                              alt="Linkedin"
                          /></a>
                          <a
                            :href="'mailto:' + data.executive_email_work"
                            :title="data.executive_email_work"
                            class="mr-1"
                            style="cursor: pointer"
                            ><img
                              src="/img/icons/mail.png"
                              height="25"
                              width="25"
                          /></a>
                          <a
                            v-if="data.linkedin_url"
                            v-on:click="openLink(data.linkedin_url)"
                            :title="data.linkedin_url"
                            style="cursor: pointer"
                            class="mr-1"
                            ><img
                              style="border-radius: 15px"
                              src="/img/linkedin-color.png"
                              height="25"
                              width="25"
                              alt="Linkedin"
                          /></a>
                          <a
                            v-if="data.twitter_url"
                            v-on:click="openLink(data.twitter_url)"
                            style="cursor: pointer"
                            :title="data.twitter_url"
                            ><img
                              src="/img/x.svg"
                              height="25"
                              width="25"
                              alt="Twitter"
                          /></a>
                        </div>
                      </div>
                      <div class="col-lg-2 col-sm-2 col-2 px-2 text-center">
                        <input
                          type="checkbox"
                          v-on:click="addToFavorite(data)"
                          :checked="data.is_fav == 1"
                        />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-12">
                      <span class="update-date"
                        >Last Updated :
                        {{
                          $helperService.getFormatedDate(data.updated_on)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              <div class="row mx-0 mb-4">
                <div class="col-lg-12 mt-5 text-center">
                  <div class="page-bottom-pagination text-right">
                    <Pagination
                      @page-change="pageChange"
                      @items-per-page-change="itemsPerPageChange"
                      ref="listPagination"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Executive Section Filter View start here (Build My Search) -->
  <div class="navbar executive-offcanvas">
    <div
      :class="
        isOpenModel
          ? 'navbar-collapse offcanvas offcanvas-collapse open'
          : 'navbar-collapse offcanvas offcanvas-collapse close'
      "
    >
      <div class="inner-filter-close">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-6 text-left">
            <h6
              class="mb-0"
              style="font-size: 15px; padding-top: 2px; color: #de4a38"
            >
              Executive
            </h6>
          </div>
          <div class="col-lg-6 col-sm-6 col-6" id="closeOffcanvas">
            <button
              class="navbar-toggler menuButton"
              v-on:click="openCloseModel()"
            >
              <img src="/img/cross.png" width="22" height="22" />
            </button>
          </div>
        </div>
      </div>
      <div class="form-group mb-3 px-3" v-if="selectedFilters.length">
        <div class="selected-filters d-flex flex-wrap mt-2">
          <span
            v-for="(filter, index) in selectedFilters"
            :key="index"
            class="selected-chip"
            style="cursor: pointer"
            @click="removeSelectedFilter(filter)"
          >
            {{ filter.name }} <span style="margin-left: 5px">&times;</span>
          </span>
        </div>
      </div>
      <div class="inner-data">
        <div class="filter-modal">
          <div class="overflowScroll">
            <div id="accordion" class="accordion">
              <div class="card mb-0">
                <!-- Current Company -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseOne"
                >
                  <a class="card-title"> Current Company</a>
                </div>
                <div id="collapseOne" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <Multiselect
                      v-model="searchObj.new_company_ids"
                      :options="companyList"
                      :multiple="true"
                      placeholder="Select"
                      label="company_name"
                      track-by="company_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCompanyName($event)"
                      @input="onCompanyChange"
                      :show-labels="true"
                    >
                    </multiselect>
                  </div>
                </div>

                <!-- ComapnySegment -->
                <div
                  v-if="isShowSegment"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwentyTwo"
                >
                  <a class="card-title">Company Segment</a>
                </div>
                <div id="collapseTwentyTwo" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(segment, index) in segmentList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.segment_ids.includes(
                            segment.id
                          ),
                          'btn-success active':
                            !searchObj.segment_ids.includes(segment.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="segment.name"
                          :value="segment.id"
                          v-model="searchObj.segment_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              segment.id,
                              'segment',
                              segment.name
                            )
                          "
                        />
                        {{ segment.name }}
                      </label>
                    </div>
                  </form>
                </div>                

                <!-- Past Company -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwo"
                >
                  <a class="card-title"> Past Company </a>
                </div>
                <div id="collapseTwo" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Past Company</label> -->
                    <multiselect
                      v-model="searchObj.prev_company_ids"
                      :options="companyList"
                      :multiple="true"
                      placeholder="Select"
                      label="company_name"
                      track-by="company_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCompanyName($event)"
                      @input="onPrevCompanyChange"
                      :show-labels="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Job Function -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  href="#collapseFour"
                >
                  <a class="card-title"> Job Function </a>
                </div>
                <div id="collapseFour" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(job, index) in jobFunctionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.job_function_ids_new.includes(
                            job.id
                          ),
                          'btn-success active':
                            !searchObj.job_function_ids_new.includes(job.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="job.job_function_name"
                          :value="job.id"
                          v-model="searchObj.job_function_ids_new"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              job.id,
                              'job_function',
                              job.job_function_name
                            )
                          "
                        />
                        {{ job.job_function_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Industry -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSix"
                >
                  <a class="card-title"> Industry </a>
                </div>
                <div id="collapseSix" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(industry, index) in getDisplayedIndustries()"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.industry_ids_new.includes(
                            industry.id
                          ),
                          'btn-success active':
                            !searchObj.industry_ids_new.includes(industry.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="industry.industry_name"
                          :value="industry.id"
                          v-model="searchObj.industry_ids_new"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              industry.id,
                              'industry',
                              industry.industry_name
                            )
                          "
                        />
                        {{ industry.industry_name }}
                      </label>
                    </div>
                    <!-- View more Button -->
                    <div class="mt-2 text-right">
                      <span v-if="!showAllIndustries" 
                        @click="handleShowMore"
                        style="cursor: pointer; 
                        font-size: 14px; 
                        color: black; 
                        font-weight: 500;">
                        view more
                      </span>
                    </div>
                  </form>
                </div>
                <!--sub sector -->
                <div
                  v-if="isShowSubsector"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSeven"
                >
                  <a class="card-title"> {{ subsectorLabel }} </a>
                </div>
                <div id="collapseSeven" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(subsector, index) in subsectorList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.subsector_ids.includes(
                            subsector.id
                          ),
                          'btn-success active':
                            !searchObj.subsector_ids.includes(subsector.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="subsector.industry_name"
                          :value="subsector.id"
                          v-model="searchObj.subsector_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              subsector.id,
                              'subsector',
                              subsector.industry_name
                            )
                          "
                        />
                        {{ subsector.industry_name }}
                      </label>
                    </div>
                  </form>
                </div>                               
                <!-- Skills -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSeventeen">
                  <a class="card-title">Skills</a>
                </div>
                <div id="collapseSeventeen" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search</label> -->
                    <multiselect
                      v-model="searchObj.skill_ids"
                      :options="skill_list"
                      :multiple="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchSkillName($event)"
                      @input="onSkillChange"
                      :show-labels="true">
                    </multiselect>
                  </div>
                </div>
                <!-- Industry Exposure -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwentyOne"
                >
                  <a class="card-title">Industry Exposure</a>
                </div>
                <div id="collapseTwentyOne" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(industry, index) in getDisplayedIndustries()"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.industry_exposureids.includes(
                            industry.id
                          ),
                          'btn-success active':
                            !searchObj.industry_exposureids.includes(industry.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="industry.industry_name"
                          :value="industry.id"
                          v-model="searchObj.industry_exposureids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              industry.id,
                              'industry_exposure',
                              industry.industry_name
                            )
                          "
                        />
                        {{ industry.industry_name }}
                      </label>
                    </div>
                    <!-- View more Button -->
                    <div class="mt-2 text-right">
                      <span v-if="!showAllIndustries" 
                        @click="handleShowMore"
                        style="cursor: pointer; 
                        font-size: 14px; 
                        color: black; 
                        font-weight: 500;">
                        view more
                      </span>
                    </div>
                  </form>
                </div>                
                <!-- Location -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThree"
                >
                  <a class="card-title"> Location </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Location</label> -->
                    <!-- <div class="tags-container">
                    <input data-role='tags-input' placeholder="Search Location" data-placeholder="Search Location"
                      value="" />
                  </div> -->
                    <multiselect
                      v-model="searchObj.country_ids"
                      :options="cityList"
                      :multiple="true"
                      placeholder="Select"
                      label="country_name"
                      track-by="country_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCityName($event)"
                      @input="onLocationChange"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Region Current -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseEleven"
                >
                  <a class="card-title"> Region Current </a>
                </div>
                <div
                  id="collapseEleven"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(region, index) in regionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.region_ids_new.includes(
                            region.id
                          ),
                          'btn-success active':
                            !searchObj.region_ids_new.includes(region.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="region.region_name"
                          :value="region.id"
                          v-model="searchObj.region_ids_new"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              region.id,
                              'region_new',
                              region.region_name
                            )
                          "
                        />
                        {{ region.region_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Gender -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseEight"
                >
                  <a class="card-title"> Gender </a>
                </div>
                <div id="collapseEight" class="card-body collapse show">
                  <div class="px-2">
                    <form>
                      <div>
                        <input
                          type="radio"
                          v-model="searchObj.gender"
                          name="gender"
                          value="male"
                          @change="handleToggle('Male', 'gender', 'Male')"
                          style="cursor: pointer;"
                        />&nbsp; Male &nbsp;&nbsp;
                        <input
                          type="radio"
                          v-model="searchObj.gender"
                          name="gender"
                          value="female"
                          @change="handleToggle('Female', 'gender', 'Female')"
                          style="cursor: pointer;"
                        />&nbsp; Female
                      </div>
                    </form>
                  </div>
                </div>                
                <!-- Geographical Exposure -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwenty">
                  <a class="card-title">Geographical Exposure</a>
                </div>
                <div id="collapseTwenty" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search</label> -->
                    <multiselect
                      v-model="searchObj.geographical_ids"
                      :options="geographicalList"
                      :multiple="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchGeographicalName($event)"
                      @input="onGeographicalChange"
                      :show-labels="true">
                    </multiselect>
                  </div>
                </div>
                <!-- Company Size -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTen"
                >
                  <a class="card-title"> Company Size </a>
                </div>
                <div id="collapseTen" class="card-body collapse">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(comapanySize, index) in company_sizes"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger':
                            searchObj.company_sizes.includes(comapanySize),
                          'btn-success active':
                            !searchObj.company_sizes.includes(comapanySize),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="comapanySize"
                          :value="comapanySize"
                          v-model="searchObj.company_sizes"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              comapanySize,
                              'company_size',
                              comapanySize
                            )
                          "
                        />
                        {{ comapanySize }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Company Type -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseNine"
                >
                  <a class="card-title"> Company Type </a>
                </div>
                <div id="collapseNine" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(comapnyType, index) in company_types"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger':
                            searchObj.company_types.includes(comapnyType),
                          'btn-success active':
                            !searchObj.company_types.includes(comapnyType),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="comapnyType"
                          :value="comapnyType"
                          v-model="searchObj.company_types"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              comapnyType,
                              'company_type',
                              comapnyType
                            )
                          "
                        />
                        {{ comapnyType }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Investor / Board Member / C-Suite - one row -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseExecutiveRole"
                >
                  <a class="card-title"> Executive Role </a>
                </div>
                <div id="collapseExecutiveRole" class="card-body collapse show">
                  <div class="px-2">
                    <form class="role-checks">
                      <label>
                        <input
                          type="checkbox"
                          name="is_invester"
                          v-model="searchObj.is_invester"
                          @change="
                            handleToggle('is_invester', 'investor', 'Investor')
                          "
                        />&nbsp; Investor
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="is_board_member"
                          v-model="searchObj.is_board_member"
                          @change="
                            handleToggle(
                              'is_board_member',
                              'board_member',
                              'Board Member'
                            )
                          "
                        />&nbsp; Board Member
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="operating_committee"
                          v-model="searchObj.operating_committee"
                          @change="
                            handleToggle(
                              'operating_committee',
                              'c_suite',
                              'C-Suite'
                            )
                          "
                        />&nbsp; C-Suite
                      </label>
                    </form>
                  </div>
                </div>
                <!-- Seniority Level -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFive"
                >
                  <a class="card-title"> Seniority Level </a>
                </div>
                <div id="collapseFive" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(seniority, index) in seniorityList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.seniority_ids.includes(
                            seniority.id
                          ),
                          'btn-success active':
                            !searchObj.seniority_ids.includes(seniority.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="seniority.seniority_name"
                          :value="seniority.id"
                          v-model="searchObj.seniority_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              seniority.id,
                              'seniority',
                              seniority.seniority_name
                            )
                          "
                        />
                        {{ seniority.seniority_name }}
                      </label>
                    </div>
                  </form>
                </div>                
                <!-- Deal Stage -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThirteen"
                >
                  <a class="card-title"> Deal Stage </a>
                </div>
                <div
                  id="collapseThirteen"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(dealStage, index) in dealStageList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.deal_stage_ids.includes(
                            dealStage.id
                          ),
                          'btn-success active':
                            !searchObj.deal_stage_ids.includes(dealStage.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="dealStage.name"
                          :value="dealStage.id"
                          v-model="searchObj.deal_stage_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              dealStage.id,
                              'deal_stage',
                              dealStage.name
                            )
                          "
                        />
                        {{ dealStage.name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Region Past -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwelve"
                >
                  <a class="card-title"> Region Past </a>
                </div>
                <div
                  id="collapseTwelve"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(region, index) in regionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.region_ids_prev.includes(
                            region.id
                          ),
                          'btn-success active':
                            !searchObj.region_ids_prev.includes(region.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="region.region_name"
                          :value="region.id"
                          v-model="searchObj.region_ids_prev"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              region.id,
                              'region_pre',
                              region.region_name
                            )
                          "
                        />
                        {{ region.region_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Hobbies & Interest -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseEighteen">
                  <a class="card-title">Hobbies & Interest</a>
                </div>
                <div id="collapseEighteen" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search</label> -->
                    <multiselect
                      v-model="searchObj.hobby_ids"
                      :options="hobby_list"
                      :multiple="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchHobbyName($event)"
                      @input="onHobbyChange"
                      :show-labels="true">
                    </multiselect>
                  </div>
                </div>
                <!--  Education -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFourteen"
                >
                  <a class="card-title"> Education </a>
                </div>
                <div
                  id="collapseFourteen"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(education, index) in educationList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.education_ids.includes(
                            education.id
                          ),
                          'btn-success active':
                            !searchObj.education_ids.includes(education.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="education.education_name"
                          :value="education.id"
                          v-model="searchObj.education_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              education.id,
                              'education',
                              education.education_name
                            )
                          "
                        />
                        {{ education.education_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- University -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFifteen"
                >
                  <a class="card-title"> University </a>
                </div>
                <div
                  id="collapseFifteen"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search University</label> -->
                    <multiselect
                      v-model="searchObj.education_institutre_name"
                      :options="universityList"
                      :multiple="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @input="onUniversityChange"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>                
                <!-- Languages -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseNineteen">
                  <a class="card-title">Languages</a>
                </div>
                <div id="collapseNineteen" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search</label> -->
                    <multiselect
                      v-model="searchObj.language_ids"
                      :options="language_list"
                      :multiple="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchLanguageName($event)"
                      @input="onLanguageChange"
                      :show-labels="true">
                    </multiselect>
                  </div>
                </div>
                <!-- Age Range -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSixteen"
                >
                  <a class="card-title"> Age Range </a>
                </div>
                <div
                  id="collapseSixteen"
                  class="card-body collapse"
                  data-parent="#accordion"
                >
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(age, index) in ageRangeList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.age_range_ids.includes(
                            age.id
                          ),
                          'btn-success active':
                            !searchObj.age_range_ids.includes(age.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="age.age_range_name"
                          :value="age.id"
                          v-model="searchObj.age_range_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              age.id,
                              'age_range',
                              age.age_range_name
                            )
                          "
                        />
                        {{ age.age_range_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- ADD YOUR NEW DROPDOWN FROM HERE  -->
              </div>
            </div>
          </div>
          <hr />
          <div
            class="d-flex justify-content-between align-items-center px-3 posfixed"
          >
            <button
              v-on:click="
                getList(0);
                openCloseModel();
              "
              class="apply-btn mr-2"
            >
              Apply
            </button>
            <button
              v-on:click="
                resetFilter();
                openCloseModel();
              "
              type="button"
              class="apply-btn"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountryFlag from "vue-country-flag-next";
import ErrorComponent from "@/components/ErrorComponent";
// import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Pagination from "@/components/Pagination";
import Multiselect from "@vueform/multiselect";
import { Field } from "vee-validate";
import "@vueform/multiselect/themes/default.css";
export default {
  name: "Executive",
  components: {
    ErrorComponent,
    Pagination,
    Multiselect,
    Field,
    CountryFlag,
    // Datepicker,
  },
  data() {
    return {
      id: this.$route.params.id,
      showDidYouMean: false,
      executive_id: this.$route.params.executive_id,
      type: this.$route.params.type,
      showAllIndustries: false,
      isShowSegment: false,
      count: 0,
      loader: true,
      isShowSubsector: false,
      subsectorLabel: "Subsector",
      searchedPrompt: "",
      company_types: [
        "Public",
        "Private",
        "Education",
        "Government",
        "Not-for-Profit",
        "Venture Funded",
        "PE Backed",
      ],
      genders: [
        {
          value: "male",
          view: "Male",
        },
        { value: "female", view: "Female" },
      ],
      searchObj: {
        gender: "",
        keyword: "",
        industry_ids_new: [],
        industry_exposureids: [],
        company_sizes: [],
        new_company_ids: [],
        education_institutre_name: [],
        prev_company_ids: [],
        job_function_ids_new: [],
        seniority_ids: [],
        company_types: [],
        country_ids: [],
        education_ids: [],
        age_range_ids: [],
        region_ids_prev: [],
        region_ids_new: [],
        deal_stage_ids: [],
        subsector_ids: [],
        skill_ids: [],
        hobby_ids: [],
        language_ids: [],
        geographical_ids: [],
        is_headquater: false,
        is_invester: false,
        is_board_member: false,
        operating_committee: false, // C-Suite
        segment_ids: [],
      },
      offset: -1,
      list: [],
      company_sizes: [
        "1-10",
        "11-50",
        "51-200",
        "201-500",
        "501-1000",
        "1001-5000",
        "5001-10000",
        "10000+",
      ],
      dealStageList: [],
      universityList: [],
      cityList: [],
      company_ids: [],
      city_ids: [],
      industryList: [],
      companyList: [],
      jobFunctionList: [],
      educationList: [],
      seniorityList: [],
      ageRangeList: [],
      regionList: [],
      subsectorList: [],
      skill_list: [],
      skillKeyword: "",
      hobby_list: [],
      hobbyKeyword: "",
      language_list: [],
      languageKeyword: "",
      geographicalList: [],
      geographicalKeyword: "",
      cityKeyword: "",
      companyKeyword: "",
      jobFunctionKeyword: "",
      educationKeyword: "",
      industryKeyword: "",
      searchGenderKeyword: "",
      ageRangeKeyword: "",
      regionKeyword: "",
      subsectorKeyword: "",
      is_show: false,
      selectedFilters: [],
      isOpenModel: false,
      prevCompanyIds: [],
      segmentList: [],
    };
  },
  mounted() {
    this.globelSearchResult();
    this.applyCompanyRegionJobfunctionFilter();
    this.industrylist();
    this.jobFunctionlist();
    this.getEducationlist();
    this.getAgeRangeList();
    this.getRegionlist();
    this.getSenioritylist();
    this.getUniversitylist();
    this.getDealStageList();
    this.getskillList();
    this.getHobbyList();
    this.getLanguageList();
    this.getGeographicalList();
    this.CityList();
    if (this.id || this.executive_id || this.type) {
      this.$shareService.getMapValueAndRemove("executive_page_filter");
    }
    if (this.id) {
      this.getExecutiveDetail(this.id);
    } else {
      this.getList(0);
    }
  },
  watch: {
    "searchObj.new_company_ids"(newVal) {
      if (newVal.length === 1) {
        const selectedCompanyId = newVal[0];
        this.getSegmentList(selectedCompanyId);
      } else {
        this.segmentList = [];
        this.isShowSegment = false;
        this.searchObj.segment_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
          (f) => f.type !== "segment"
        );
      }
    },

    "searchObj.industry_ids_new"(newVal) {
      if (newVal.length === 1) {
        const selectedIndustryId = newVal[0];
        this.onIndustryChange(selectedIndustryId);
      } else {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.searchObj.subsector_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
          (f) => !(f.type === "subsector")
        );
      }
    },
    // Scroll hide when Offcanvas open
    isOpenModel(newVal) {
    if (newVal) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }

  },

  methods: {
    getDisplayedIndustries() {
      return this.showAllIndustries ? this.industryList : this.industryList.slice(0, 15);
    },
    handleShowMore() {
      this.showAllIndustries = true;
    },
    openCloseModel() {
      this.isOpenModel = !this.isOpenModel;
    },
    removeSelectedFilter(filter) {
      console.log("Removing filter:", filter);
      if (filter.type === "job_function") {
        this.searchObj.job_function_ids_new =
          this.searchObj.job_function_ids_new.filter((id) => id !== filter.id);
      } else if (filter.type === "industry") {
        this.searchObj.industry_ids_new =
          this.searchObj.industry_ids_new.filter((id) => id !== filter.id);
      } else if (filter.type === "education") {
        this.searchObj.education_ids = this.searchObj.education_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "age_range") {
        this.searchObj.age_range_ids = this.searchObj.age_range_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "seniority") {
        this.searchObj.seniority_ids = this.searchObj.seniority_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "region_new") {
        this.searchObj.region_ids_new = this.searchObj.region_ids_new.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "region_prev") {
        this.searchObj.region_ids_prev = this.searchObj.region_ids_prev.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company_type") {
        this.searchObj.company_types = this.searchObj.company_types.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company_size") {
        this.searchObj.company_sizes = this.searchObj.company_sizes.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "deal_stage") {
        this.searchObj.deal_stage_ids = this.searchObj.deal_stage_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "gender") {
        this.searchObj.gender = "";
      } else if (filter.type === "company" && filter.id != null) {
        this.searchObj.new_company_ids = this.searchObj.new_company_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "prevcompany") {
        this.searchObj.prev_company_ids =
          this.searchObj.prev_company_ids.filter((id) => id !== filter.id);
      } else if (filter.type === "location") {
        this.searchObj.country_ids = this.searchObj.country_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "skill") {
        this.searchObj.skill_ids = this.searchObj.skill_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "university") {
        this.searchObj.education_institutre_name =
          this.searchObj.education_institutre_name.filter(
            (id) => id !== filter.id
          );
      } else if (filter.type === "subsector") {
        this.searchObj.subsector_ids = this.searchObj.subsector_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "hobby") {
        this.searchObj.hobby_ids = this.searchObj.hobby_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "language") {
        this.searchObj.language_ids = this.searchObj.language_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "geographical") {
        this.searchObj.geographical_ids = this.searchObj.geographical_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "industry_exposure") {
        this.searchObj.industry_exposureids = this.searchObj.industry_exposureids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "segment") {
        this.searchObj.segment_ids = this.searchObj.segment_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "investor") {
        this.searchObj.is_invester = false;
      } else if (filter.type === "board_member") {
        this.searchObj.is_board_member = false;
      } else if (filter.type === "c_suite") {
        this.searchObj.operating_committee = false;
      }

      // This line ensures it's removed visually too
      this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.id === filter.id && f.type === filter.type)
      );
    },
    onCompanyChange(selectedIds) {
      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id == id && f.type == "company"
        );
        if (!exists) {
          const company = this.companyList.find((c) => c.id == id);
          if (company) {
            this.selectedFilters.push({
              id: company.id,
              name: company.company_name,
              type: "company",
            });
          }
        }
      });
      // remove object from this.selectedFilters if not in selectedIds
      this.selectedFilters = this.selectedFilters.filter(
        (filter) => filter.type != "company" || selectedIds.includes(filter.id)
      );
      this.searchObj.new_company_ids = selectedIds;
    },
    onPrevCompanyChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "prevcompany" || selectedIds.includes(filter.id)
      );
      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "prevcompany"
        );
        if (!exists) {
          const company = this.companyList.find((c) => c.id === id);
          if (company) {
            this.selectedFilters.push({
              id: company.id,
              name: company.company_name,
              type: "prevcompany",
            });
          }
        }
      });
    },
    onLocationChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "location" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "location"
        );
        if (!exists) {
          const country = this.cityList.find((c) => c.id === id);
          if (country) {
            this.selectedFilters.push({
              id: country.id,
              name: country.country_name,
              type: "location",
            });
          }
        }
      });
    },
    onSkillChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "skill" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "skill"
        );
        if (!exists) {
          const skill = this.skill_list.find((c) => c.id === id);
          if (skill) {
            this.selectedFilters.push({
              id: skill.id,
              name: skill.name,
              type: "skill",
            });
          }
        }
      });
    },
    onHobbyChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "hobby" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "hobby"
        );
        if (!exists) {
          const hobby = this.hobby_list.find((c) => c.id === id);
          if (hobby) {
            this.selectedFilters.push({
              id: hobby.id,
              name: hobby.name,
              type: "hobby",
            });
          }
        }
      });
    },
    onLanguageChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "language" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "language"
        );
        if (!exists) {
          const language = this.language_list.find((c) => c.id === id);
          if (language) {
            this.selectedFilters.push({
              id: language.id,
              name: language.name,
              type: "language",
            });
          }
        }
      });
    },
    onGeographicalChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "geographical" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "geographical"
        );
        if (!exists) {
          const geographical = this.geographicalList.find((c) => c.id === id);
          if (geographical) {
            this.selectedFilters.push({
              id: geographical.id,
              name: geographical.name,
              type: "geographical",
            });
          }
        }
      });
    },
    onIndustryExposureChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "industry_exposure" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "industry_exposure"
        );
        if (!exists) {
          const industry_exposure = this.indu.find((c) => c.id === id);
          if (industry_exposure) {
            this.selectedFilters.push({
              id: industry_exposure.id,
              name: industry_exposure.name,
              type: "industry_exposure",
            });
          }
        }
      });
    },    
    onUniversityChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "university" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "university"
        );
        if (!exists) {
          const university = this.universityList.find((c) => c.id === id);
          if (university) {
            this.selectedFilters.push({
              id: university.id,
              name: university.name,
              type: "university",
            });
          }
        }
      });
    },
    handleToggle(id, type, name = "") {
      // For radio-type values like gender, remove existing same-type filters
      if (type === "gender") {
        this.selectedFilters = this.selectedFilters.filter(
          (item) => item.type !== "gender"
        );
      }
      const exists = this.selectedFilters.find(
        (item) => item.id === id && item.type === type
      );
      if (!exists) {
        this.selectedFilters.push({
          id: id,
          name: name,
          type: type,
        });
      } else {
        this.selectedFilters = this.selectedFilters.filter(
          (item) => !(item.id === id && item.type === type)
        );
      }
    },
    resetFilter() {
      this.searchObj = {};
      this.searchObj.gender = "";
      this.searchObj.education_institutre_name = [];
      this.searchObj.keyword = "";
      this.searchObj.industry_ids_new = [];
      this.searchObj.industry_exposureids = [];
      this.searchObj.new_company_ids = [];
      this.searchObj.prev_company_ids = [];
      this.searchObj.job_function_ids_new = [];
      this.searchObj.seniority_ids = [];
      this.searchObj.company_types = [];
      this.searchObj.city_id = "";
      this.searchObj.education_ids = [];
      this.searchObj.company_sizes = [];
      this.searchObj.age_range_ids = [];
      this.searchObj.region_ids_new = [];
      this.searchObj.region_ids_prev = [];
      this.searchObj.deal_stage_ids = [];
      this.searchObj.subsector_ids = [];
      this.searchObj.is_invester = false;
      this.searchObj.is_board_member = false;
      this.searchObj.operating_committee = false;
      this.isShowSubsector = false;
      this.selectedFilters = [];
      this.showDidYouMean = false;
      this.getList(0);
    },
    getAdvanceSearch() {
      this.is_show = !this.is_show;
    },
    addToFavorite(data) {
      var obj = {};
      obj.executive_id = data.id;
      this.$api
        .putAPI({
          _action: "/add/executive/fav",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.is_fav = data.is_fav == 1 ? 0 : 1);
          // this.getList(0);data.is_fav
          // this.$router.push("/executive");
        })
        .catch(() => {});
    },
    /**
     * Added a new 3-section layout in the company details page:
     * - Regional Leadership, Functional Leadership, and Interesting Facts (all are executive-wise lists).
     * - Clicking on Regional/Functional Leadership redirects to the executive page:
     *   - If Regional Leadership is clicked, the regional & company filter is applied.
     *   - If Functional Leadership is clicked, the job function & company filter is applied.
     * - Clicking on Interesting Facts (a topic-wise list) redirects to the commentary page with both company and topic filters applied.
     */
    applyCompanyRegionJobfunctionFilter() {
      let companyId = this.$route.params.company_id;
      this.getSegmentList(companyId);
      if (companyId) {
        this.company_ids.push(companyId);
        this.searchObj.new_company_ids.push(companyId);
        this.selectedFilters.push({
          id: companyId,
          name: "",
          type: "company",
        });
      }
      this.companylist();
      if (this.$route.params.type == "REGION") {
        this.searchObj.region_ids_new.push(Number(this.$route.params.item_id));
        this.selectedFilters.push({
          id: Number(this.$route.params.item_id),
          name: "",
          type: "region_new",
        });
        this.is_show = true;
      } else if (this.$route.params.type == "JOB_FUNCTION") {
        this.searchObj.job_function_ids_new.push(
          Number(this.$route.params.item_id)
        );
        this.selectedFilters.push({
          id: Number(this.$route.params.item_id),
          name: "",
          type: "job_function",
        });
        this.is_show = true;
      } else if (this.$route.params.type == "HQ") {
        this.searchObj.is_headquater = true;
        //
      } else if (this.$route.params.type == "SEGMENT") {
        const segmentId = Number(this.$route.params.item_id);
        this.searchObj.segment_ids.push(Number(segmentId));
        this.selectedFilters.push({
          id: segmentId,
          name: "",
          type: "segment",
        });
      }
    },
    openLink(url) {
      window.open(url);
    },
    searchGenderName(e) {
      this.searchGenderKeyword = e;
      this.genders;
    },
    searchJobFunctionName(e) {
      this.jobFunctionKeyword = e;
      this.jobFunctionlist();
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.industrylist();
    },
    onIndustryChange(selectedIndustryId) {
      if (selectedIndustryId) {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.getSubsectorList(selectedIndustryId);
        this.dynamicSubsectorName(selectedIndustryId); //This function is added to get the dynamic name when selecting the industry.
      } else {
        this.isShowSubsector = false;
        this.subsectorList = [];
      }
    },

    dynamicSubsectorName(selectedIndustryId) {
      const selectedIndustry = this.industryList.find(
        (industry) => industry.id === selectedIndustryId
      );

      if (selectedIndustry && selectedIndustry.industry_name) {
        if ("Technology" == selectedIndustry.industry_name) {
          this.subsectorLabel = "Tech Focus";
        } else if ("Financial Services" == selectedIndustry.industry_name) {
          this.subsectorLabel = "FS Focus";
        } else {
          this.subsectorLabel = "Subsector";
        }
      }
    },
    globelSearchResult() {
      let filters = this.$shareService.getMapValueAndRemove("global_search_filter");    
      if (filters && Object.keys(filters).length > 0) {
        // Did you mean
        this.showDidYouMean = filters.flag;
        this.searchedPrompt = filters.prompt;
        
        let current_companyid =
          filters.coid && filters.coid != 0 ? Number(filters.coid) : "";   // current company
        if (current_companyid) {
          this.searchObj.new_company_ids.push(current_companyid);
          this.company_ids.push(current_companyid);
          this.selectedFilters.push({
            id: current_companyid,
            name: "",
            type: "company",
          });
        }

        // past company
        let past_companyid =
          filters.pcid && filters.pcid != 0 ? Number(filters.pcid) : "";  // past company
        if (past_companyid) {
          this.searchObj.prev_company_ids.push(past_companyid);
          this.company_ids.push(past_companyid);
          this.selectedFilters.push({
            id: past_companyid,
            name: "",
            type: "prevcompany",
          });
        }


        let countryId =
          filters.cid && filters.cid != 0 ? Number(filters.cid) : ""; // Location(country)
        if (countryId) {
          this.searchObj.country_ids.push(countryId);
          this.selectedFilters.push({
            id: countryId,
            name: "",
            type: "location",
          });
        }


        let job_function =
          filters.jid && filters.jid != 0 ? Number(filters.jid) : ""; // Job Function
        if (job_function) {
          this.searchObj.job_function_ids_new.push(job_function);
          this.selectedFilters.push({
            id: job_function,
            name: "",
            type: "job_function",
          });
        }

        // Industry
        let industryId =
          filters.iid && filters.iid != 0 ? Number(filters.iid) : "";   // INdustry
        if (industryId) {
          this.searchObj.industry_ids_new.push(industryId);
          this.selectedFilters.push({
            id: industryId,
            name: "",
            type: "industry",
          });

            let subsectorid =
              filters.ssid && filters.ssid != 0 ? Number(filters.ssid) : "";   // Subsector
            if (subsectorid) {
              this.searchObj.subsector_ids.push(subsectorid);
              this.selectedFilters.push({
                id: subsectorid,
                name: "",
                type: "subsector",
              });  
            }
            this.getSubsectorList(industryId);
        }

        let gender =
          filters.g ? this.$helperService.getTitleCase(filters.g) : ""; // gender but need to change this
        if (gender) {
          this.searchObj.gender = gender.toLowerCase();
          this.selectedFilters.push({
            id: gender,
            name: gender,
            type: "gender",
          });
        }

        let companyType = filters.ctype ?? "";  // company type
        if (companyType) {
          this.searchObj.company_types.push(
            this.$helperService.getCompanyTypeLabel(companyType)
          );
          this.selectedFilters.push({
            id: this.$helperService.getCompanyTypeLabel(companyType),
            name: this.$helperService.getCompanyTypeLabel(companyType),
            type: "company_type",
          });
        }

        let companySize = filters.cs ?? "";
        if (companySize) {
          this.searchObj.company_sizes.push(companySize);     // company size
          this.selectedFilters.push({
            id: companySize,
            name: companySize,
            type: "company_size",
          });
        }

        let current_regionid =
          filters.rid && filters.rid != 0 ? Number(filters.rid) : "";  // current region
        if (current_regionid) {
          this.searchObj.region_ids_new.push(current_regionid);
          this.selectedFilters.push({
            id: current_regionid,
            name: "",
            type: "region_new",
          });
        }

        let past_regionid =
          filters.prid && filters.prid != 0 ? Number(filters.prid) : "";  // past region
        if (past_regionid) {
          this.searchObj.region_ids_prev.push(past_regionid);
          this.selectedFilters.push({
            id: past_regionid,
            name: "",
            type: "region_prev",
          });
        }

        let stageId =
          filters.sid && filters.sid != 0 ? Number(filters.sid) : ""; // deal stage
        if (stageId) {
          this.searchObj.deal_stage_ids.push(stageId);
          this.selectedFilters.push({
            id: stageId,
            name: "",
            type: "deal_stage",
          });
        }

        let educationid =
          filters.eid && filters.eid != 0 ? Number(filters.eid) : "";  // education
        if (educationid) {
          this.searchObj.education_ids.push(educationid);
          this.selectedFilters.push({
            id: educationid,
            name: "",
            type: "education",
          });
        }

        let univerityid =
          filters.uid && filters.uid != 0 && filters.uid != "" ? filters.uid : "";  // university
        if (univerityid) {          
          this.searchObj.education_institutre_name.push(univerityid);   // universityid is comes as a university-name
          // this.educationKeyword = univerityid;
          this.selectedFilters.push({
            id: univerityid,
            name: univerityid,
            type: "university",
          });
          
          if (this.universityList.length === 0) {
            this.universityList.push({
              id: univerityid,
              name: univerityid
            });
          }
        }

        let age_range =
          filters.ar && filters.ar != 0 ? Number(filters.ar) : "";  // age range
        if (age_range) {
          this.searchObj.age_range_ids.push(age_range);
          this.selectedFilters.push({
            id: age_range,
            name: "",
            type: "age_range",
          });
        }

        let seniorityid =
          filters.seid && filters.seid != 0 ? Number(filters.seid) : "";  // seniority level
        if (seniorityid) {
          this.searchObj.seniority_ids.push(seniorityid);
          this.selectedFilters.push({
            id: seniorityid,
            name: "",
            type: "seniority",
          });
        }        

        // dashboard sentence search: skills, and the picked names so the
        // chips read right away
        (filters.skills || []).forEach((skill) => {
          this.searchObj.skill_ids.push(skill.id);
          this.selectedFilters.push({ id: skill.id, name: skill.name, type: "skill" });
        });
        if (filters.labels) {
          this.selectedFilters.forEach((filter) => {
            if (!filter.name && filters.labels[filter.type]) {
              filter.name = filters.labels[filter.type];
            }
          });
        }
      }
    },
    searchSeniorityName(e) {
      this.seniorityKeyword = e;
      this.getSenioritylist();
    },
    searchEducationName(e) {
      this.educationKeyword = e;
      this.getEducationlist();
    },
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },
    inputCurrentCompany(id) {
      if (id) {
        // Find the selected company
        const selectedCompany = this.companyList.find(
          (company) => company.id === id
        );

        if (selectedCompany) {
          this.searchObj.industry_ids_new.push(selectedCompany.industry_id);
          this.getSubsectorList(selectedCompany.industry_id);
          if (this.subsectorList) {
            this.searchObj.subsector_ids.push(selectedCompany.subsector_id);
          }
        }
      }
    },
    searchCityName(e) {
      this.cityKeyword = e;
      this.CityList();
    },
    searchRegionName(e) {
      this.regionKeyword = e;
      this.getRegionlist();
    },
    searchAgeRangeName(e) {
      this.ageRangeKeyword = e;
      this.getAgeRangeList();
    },
    getAgeRangeList() {
      var obj = {};
      if (this.ageRangeKeyword) {
        obj.keyword = this.ageRangeKeyword;
      }
      this.$api
        .getAPI({
          _action: "/age/range/list",
          _body: obj,
        })
        .then((res) => {
          this.ageRangeList = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    },
    getSegmentList(id) {
      if (!id) return;
      this.$api
        .getAPI({
          _action: "/segment/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.segmentList = this.$helperService.removePlaceholderOptions(res);

          // Only show segment dropdown if there are segment(of company) available
          if (this.segmentList.length > 0) {
            this.isShowSegment = true;
          } else {
            this.isShowSegment = false;
          }

          // prefill if comes from global or redirect from company search -- to show name in selected filters
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "segment"
                ) {
                  this.selectedFilters[i].name = res[j].name;
                }
              }
            }
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },
    searchSkillName(e) {
      if (e) {
        this.skillKeyword = e;
        this.getskillList();
      }
    },    
    getskillList() {
      var obj = {};
      if (this.skillKeyword) {
        obj.keyword = this.skillKeyword;
      }
      this.$api
        .getAPI({
          _action: "/skills/list",
          _body: obj,
        })
        .then((res) => {
          this.skill_list = this.$helperService.removePlaceholderOptions(res);
          // keep picked skills that fall outside this page of results, so their
          // tags still show a name
          this.selectedFilters
            .filter((f) => f.type === "skill" && !this.skill_list.some((s) => s.id === f.id))
            .forEach((f) => this.skill_list.push({ id: f.id, name: f.name }));
        })
        .catch(() => {});
    },    
    searchHobbyName(e) {
      if (e) {
        this.hobbyKeyword = e;
        this.getHobbyList();
      }
    },
    getHobbyList() {
      var obj = {};
      if (this.hobbyKeyword) {
        obj.keyword = this.hobbyKeyword;
      }
      this.$api
        .getAPI({
          _action: "/hobbies/list",
          _body: obj,
        })
        .then((res) => {
          this.hobby_list = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    },
    searchLanguageName(e) {
      if (e) {
        this.languageKeyword = e;
        this.getLanguageList();
      }
    },
    getLanguageList() {
      var obj = {};
      if (this.languageKeyword) {
        obj.keyword = this.languageKeyword;
      }
      this.$api
        .getAPI({
          _action: "/languages/list",
          _body: obj,
        })
        .then((res) => {
          this.language_list = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    },
    searchGeographicalName(e) {
      this.geographicalKeyword = e;
      this.getGeographicalList();
    },
    getGeographicalList() {
      var obj = {};
      if (this.geographicalKeyword) {
        obj.keyword = this.geographicalKeyword;
      }
      this.$api
        .getAPI({
          _action: "/geographical-exposure/list",
          _body: obj,
        })
        .then((res) => {
          this.geographicalList = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    },
    getRegionlist() {
      var obj = {};
      if (this.regionKeyword) {
        obj.keyword = this.regionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/region/list",
          _body: obj,
        })
        .then((res) => {
          this.regionList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "region_new"
                ) {
                  this.selectedFilters[i].name = res[j].region_name;
                }
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "region_prev"
                ) {
                  this.selectedFilters[i].name = res[j].region_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    jobFunctionlist() {
      var obj = {};
      if (this.jobFunctionKeyword) {
        obj.keyword = this.jobFunctionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/job/function/list",
        })
        .then((res) => {
          this.jobFunctionList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "job_function"
                ) {
                  this.selectedFilters[i].name = res[j].job_function_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    getSenioritylist() {
      var obj = {};
      if (this.seniorityKeyword) {
        obj.keyword = this.seniorityKeyword;
      }
      this.$api
        .getAPI({
          _action: "/seniority/list",
          _body: obj,
        })
        .then((res) => {
          this.seniorityList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "seniority"
                ) {
                  this.selectedFilters[i].name = res[j].seniority_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    getEducationlist() {
      var obj = {};
      if (this.educationKeyword) {
        obj.keyword = this.educationKeyword;
      }
      this.$api
        .getAPI({
          _action: "/education/list",
          _body: obj,
        })
        .then((res) => {
          this.educationList = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    },
    getUniversitylist() {
      var obj = {};
      if (this.educationKeyword) {
        obj.keyword = this.educationKeyword;
      }
      this.$api
        .getAPI({
          _action: "/university/list",
          _body: obj,
        })
        .then((res) => {
          this.universityList = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    },
    closesub(e) {
      if (!e) {
        this.searchObj.subsector_ids = [];
      }
    },
    getDealStageList() {
      var obj = {};
      if (this.dealStageKeyword) {
        obj.keyword = this.dealStageKeyword;
      }
      this.$api
        .getAPI({
          _action: "/deal/stage/list",
          _body: obj,
        })
        .then((res) => {
          this.dealStageList = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    },
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      if (this.company_ids) {
        obj.company_ids = this.company_ids;
      }

      if (this.selectedFilters && this.selectedFilters.length > 0) {
        var selectedCompanies = this.selectedFilters
          .filter((filter) => filter.type == "company")
          .map((filter) => filter.id);

        var selectedPrevCompanies = this.selectedFilters
          .filter((filter) => filter.type == "prevcompany")
          .map((filter) => filter.id);

        if (selectedPrevCompanies) {
          selectedCompanies.push(...selectedPrevCompanies);
        }

        if (selectedCompanies) {
          obj.company_ids = selectedCompanies;
        }
      }

      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          if (this.companyKeyword || this.company_ids?.length > 0) {
            this.companyList = this.$helperService.removePlaceholderOptions(res);
            if (this.selectedFilters && this.selectedFilters.length > 0) {
              for (var i in this.selectedFilters) {
                for (var j in res) {
                  if (
                    res[j].id == this.selectedFilters[i].id &&
                    this.selectedFilters[i].type == "company"
                  ) {
                    this.selectedFilters[i].name = res[j].company_name;
                  }
                  if (
                    res[j].id == this.selectedFilters[i].id &&
                    this.selectedFilters[i].type == "prevcompany"
                  ) {
                    this.selectedFilters[i].name = res[j].company_name;
                  }
                }
              }
            }
          }
        })
        .catch(() => {});
    },

    industrylist() {
      this.$api
        .getAPI({
          _action: "/industry/list",
        })
        .then((res) => {
          this.industryList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "industry"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.subsectorList = this.$helperService.removePlaceholderOptions(res);

          // Only show subsector dropdown if there are subsectors(of industry) available
          if (this.subsectorList.length > 0) {
            this.isShowSubsector = true;
            this.is_show = true;
          } else {
            this.isShowSubsector = false;
          }

          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "subsector"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },
    CityList() {
      var obj = {};
      if (this.cityKeyword) {
        obj.keyword = this.cityKeyword;
      }
      if ((this.city_ids, length > 0)) {
        obj.city_ids = this.city_ids;
      }
      this.$api
        .getAPI({
          _action: "/country/list",
          _body: obj,
        })
        .then((res) => {
          this.cityList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "location"
                ) {
                  this.selectedFilters[i].name = res[j].country_name;
                }
              }
            }
          }
          // if (this.cityKeyword) {
          //   this.cityList = res;
          // } else {
          //   this.cityList = [];
          // }
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getExecutiveDetail(id) {
      if (id) {
        if (this.type == "PAST") {
          this.is_show = true;
          this.searchObj.prev_company_ids.push(id);
          this.selectedFilters.push({
            id: Number(id),
            name: "-",
            type: "prevcompany",
          });
        }
        if (this.type == "CURRENT") {
          this.is_show = true;
          this.searchObj.new_company_ids.push(id);
          this.selectedFilters.push({
            id: Number(id),
            name: "-",
            type: "company",
          });
        } else if (!this.type) {
          this.$api
            .getAPI({
              _action: "/executive/detail/" + id,
            })
            .then((res) => {
              if (res.new_company_id) {
                this.searchObj.job_function_ids_new.push(
                  res.job_function_id_new
                );
                this.selectedFilters.push({
                  id: res.job_function_id_new,
                  name: res.new_function?.job_function_name,
                  type: "job_function",
                });
                if (res.industry_id_new !== null && res.industry_id_new !== 0) {
                  this.searchObj.industry_ids_new.push(res.industry_id_new);
                  this.selectedFilters.push({
                    id: res.industry_id_new,
                    name: res.new_industry?.industry_name,
                    type: "industry",
                  });
                  if (this.searchObj.industry_ids_new.length === 1) {
                    const selectedIndustryId = this.searchObj.industry_ids_new[0];
                    this.onIndustryChange(selectedIndustryId);
                  }
                }
                this.searchObj.seniority_ids.push(res.seniority_id);
                this.selectedFilters.push({
                  id: res.seniority_id,
                  name: res.new_seniority?.seniority_name,
                  type: "seniority",
                });
                this.searchObj.country_ids.push(res.country_id);
                this.selectedFilters.push({
                  id: res.country_id,
                  name: res.country?.country_name,
                  type: "location",
                });
                this.is_show = !this.is_show;
                if (res.new_company) {
                  this.searchObj.company_types.push(
                    this.$helperService.getTitleCase(
                      res.new_company.company_type
                    )
                  );
                  this.selectedFilters.push({
                    id: this.$helperService.getTitleCase(
                      res.new_company.company_type
                    ),
                    name: this.$helperService.getTitleCase(
                      res.new_company.company_type
                    ),
                    type: "company_type",
                  });
                }
              }
              this.getList(0);
            })
            .catch(() => {});
        }
        this.company_ids.push(id);
        this.companylist();
        this.getSenioritylist();
        if (this.type) {
          this.getList(0);
        }
      }
    },
    goToView(url) {
      this.searchObj.is_show = this.is_show;
      this.$shareService.setMapValue("executive_page_filter", this.searchObj);
      this.$router.push(url);
    },
    getList(page, type) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];

      if (this.type == "PAST") {
        // this.searchObj.prev_company_ids = this.id;
      } else if (this.type == "CURRENT") {
        // this.searchObj.new_company_id = this.id;
      }
      if (!this.searchObj.gender) {
        this.searchObj.gender = "";
      }
      if (!this.searchObj.keyword) {
        this.searchObj.keyword = "";
      }
      if (!this.searchObj.company_sizes) {
        this.searchObj.company_sizes = "";
      }
      if (!this.searchObj.industry_ids_new) {
        this.searchObj.industry_ids_new = "";
      }
      if (!this.searchObj.industry_exposureids) {
        this.searchObj.industry_exposureids = [];
      }      
      if (!this.searchObj.new_company_ids) {
        this.searchObj.new_company_ids = [];
      }
      if (!this.searchObj.prev_company_ids) {
        this.searchObj.prev_company_ids = [];
      }
      if (!this.searchObj.job_function_ids_new) {
        this.searchObj.job_function_ids_new = [];
      }
      if (!this.searchObj.education_institutre_name) {
        this.searchObj.education_institutre_name = [];
      }
      if (!this.searchObj.seniority_ids) {
        this.searchObj.seniority_ids = "";
      }
      if (!this.searchObj.company_types) {
        this.searchObj.company_types = [];
      }
      if (!this.searchObj.city_id) {
        this.searchObj.city_id = "";
      }
      if (!this.searchObj.education_ids) {
        this.searchObj.education_ids = [];
      }
      if (!this.searchObj.age_range_ids) {
        this.searchObj.age_range_ids = [];
      }
      if (!this.searchObj.region_ids_prev) {
        this.searchObj.region_ids_prev = [];
      }
      if (!this.searchObj.region_ids_new) {
        this.searchObj.region_ids_new = [];
      }
      if (!this.searchObj.company_types) {
        this.searchObj.company_types = [];
      }
      if (!this.searchObj.is_headquater) {
        this.searchObj.is_headquater = "";
      }
      if (!this.searchObj.is_invester) {
        this.searchObj.is_invester = "";
      }
      if (!this.searchObj.is_board_member) {
        this.searchObj.is_board_member = "";
      }
      if (!this.searchObj.operating_committee) {
        this.searchObj.operating_committee = "";
      }
      if (this.id && !this.type) {
        this.searchObj.id = this.id;
        this.searchObj.executive_id = this.id;
      }
      if (this.offset != page) {
        this.searchObj.offset = page;
      } else {
        this.searchObj.offset = page;
      }
      if (type) {
        this.searchObj.list_type = type;
      }
      var filter_obj = this.$shareService.getMapValue("executive_page_filter")
        ? this.$shareService.getMapValue("executive_page_filter")
        : null;
      if (filter_obj) {
        this.searchObj = filter_obj;
        this.is_show = this.searchObj.is_show;
        this.$shareService.getMapValueAndRemove("executive_page_filter");
        if (this.searchObj.new_company_ids) {
          this.company_ids.push(this.searchObj.new_company_ids);
        }
        if (this.searchObj.prev_company_ids) {
          this.company_ids.push(this.searchObj.prev_company_ids);
        }
        this.companylist();
      }

      this.$api
        .getAPI({
          _action: "/executive/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.count = res.count;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
                this.$refs.listPagination.setCurrentPage(
                  this.searchObj.offset + 1
                );
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "No executive are available"
            );
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}
[data-toggle="buttons"] > .btns input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btns input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: relative !important;
  left: 0 !important;
}
label.btns.btn-block.btn-success.active,
label.btns.btn-block.btn-danger {
  border-radius: 15px;
  font-size: 11px;
  color: black;
  margin: 2px;
  padding: 4px 12px;
  font-weight: normal;
  cursor: pointer;
}
label.btns.btn-block.btn-success.active {
  background-color: #e2f0d9;
}
label.btns.btn-block.btn-danger {
  background: #d2ecff;
}
.btn-block {
  display: inline-block;
  width: auto;
}
.card .card-body {
  padding: 2px;
  margin: 0;
}
.input-tags {
  width: 100%;
  padding: 15px;
  display: block;
  margin: 0 auto;
}
.tags-container .tag {
  position: relative;
  padding-right: 24px;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-left: 0.4em;
  font-size: 85%;
  margin-left: 0.25rem;
}
.card-title {
  font-size: 13px;
}

.selected-chip {
  background-color: #d2ecff; /* light green */
  border-radius: 15px;
  font-size: 12px;
  color: black;
  margin: 2px;
  padding: 10px 20px;
  font-weight: normal;
  cursor: pointer;
}

.remove-icon {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
}

.custom-tag {
  background-color: #3490dc; /* Bootstrap primary blue */
  color: white;
  padding: 3px 8px;
  margin: 2px 3px;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  font-size: 13px;
}

/* Investor / Board Member / C-Suite checkboxes on one row */
.role-checks {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 18px;
}

.role-checks label {
  display: inline-flex;
  align-items: center;
  margin: 0;
  font-weight: normal;
  white-space: nowrap;
  cursor: pointer;
}

.role-checks input {
  cursor: pointer;
}
</style>
